import { CrowBeeldkwaliteitScore } from './crowBeeldkwaliteitScore';

export function crowBeeldkwaliteitScoreToConditionScore(crowScore?: CrowBeeldkwaliteitScore) {
    switch (crowScore) {
        case 'A+':
            return '0';
        case 'A':
            return '1';
        case 'B':
            return '2';
        case 'C':
            return '3';
        case 'D':
            return '4';
        case 'NVT':
            return '5';
        default:
            return 'U';
    }
}
